import {
	accessDenied,
	noTransactionFound,
	notFound,
	serviceUnavailable,
	unauthorized,
} from "@shared/routes/technical"
import { Navigate } from "react-router-dom"

import { AccessDeniedPage } from "../access-denied"
import { AuthPage } from "../auth"
import { NoTransactionFoundPage } from "../no-transaction-found"
import { NotFoundPage } from "../not-found"
import { RootRedirect } from "../root-redirect"
import { ServiceUnavailablePage } from "../service-unavailable"
import { UnauthorizedPage } from "../unauthorized"

export default [
	{
		index: true,
		element: <RootRedirect />,
	},
	{
		path: "auth",
		element: <AuthPage />,
	},
	{
		path: "auth/callback/logout",
		element: <Navigate to="/transactions" replace />,
	},
	{
		path: accessDenied,
		element: <AccessDeniedPage />,
	},
	{
		path: serviceUnavailable,
		element: <ServiceUnavailablePage />,
	},
	{
		path: unauthorized,
		element: <UnauthorizedPage />,
	},
	{
		path: noTransactionFound,
		element: <NoTransactionFoundPage />,
	},
	{
		path: notFound,
		element: <NotFoundPage />,
	},
]
